import { Injectable } from "@angular/core";
import { reportProgress } from "@ankaadia/ankaadia-shared-frontend";
import {
    CollectionListDto,
    ExcelAddInDto,
    GetCandidateDataGQL,
    GetCollectionListGQL,
    TableMode,
} from "@ankaadia/graphql";
import { Observable, map } from "rxjs";

@Injectable({ providedIn: "root" })
export class CandidateDataService {
  constructor(
    private readonly getCandidateDataQuery: GetCandidateDataGQL,
    private readonly getCollectionListQuery: GetCollectionListGQL
  ) {}

  getCandidateData(
    orgId: string,
    tableMode: TableMode,
    language: string,
    collectionId?: string,
    collectionOwnerId?: string
  ): Observable<ExcelAddInDto> {
    return this.getCandidateDataQuery
      .subscribe({
        input: {
          organizationId: orgId,
          tableMode: tableMode,
          language: language,
          collectionId: collectionId,
          collectionOwnerId: collectionOwnerId,
        },
      })
      .pipe(
        map((result) => result.data.getCandidateData),
        reportProgress("getCandidateData", "1", false, { silent: true })
      );
  }

  getCollectionData(): Observable<CollectionListDto> {
    return this.getCollectionListQuery.subscribe().pipe(
      map((result) => result.data.getCollectionList),
      reportProgress("getCollectionList", "1", false, { silent: true })
    );
  }

  deleteAllButFirstTable(): void {
    void Excel.run(async (context) => {
      const worksheets = context.workbook.worksheets;
      worksheets.load("items");

      await context.sync();

      if (worksheets.items.length > 1) {
        for (let i = 1; i < worksheets.items.length; i++) {
          worksheets.items[i].delete();
          await context.sync();
        }
      }
    });
  }
}
